import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { Btn, H4 } from "../../../../../AbstractElements";
import Divider from "../../../../../CommonElements/Divider";
import LearningPlanContainer from "../../../../../container/UserGroupLearningPlanContainer";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../ReduxToolkit/Hooks";
import {
  deleteUserPlanByIds,
  getUserGroupByIdByUserId,
  updateUserInduvidualPlan,
} from "../../../../../ReduxToolkit/Reducers/UserGroupSlice";
import { Done } from "../../../../../utils/Constant";
import "./style.scss";
import { formatDate } from "../../../../../utils/helper/helper";

const ModifyLearningPlan = ({
  group_id,
  selectedId,
  openModal,
  handleModal,
  learningPlan,
}) => {
  const dispatch = useAppDispatch();
  const { userGroupByIdByUserId } = useAppSelector(state => state.userGroup);
  const [addedLearningPlans, setAddedLearningPlans] = useState([]);
  const [oldAddedLearningPlans, setOldAddedLearningPlans] = useState([]);
  const [userCardDetail, setUserCardDetail] = useState([]);

  useEffect(() => {
    const addedIds = [];
    const addedCards = [];
    if (userGroupByIdByUserId && userGroupByIdByUserId?.learning_plans) {
      userGroupByIdByUserId?.learning_plans?.map(item => {
        addedIds.push(item?.id);
        addedCards.push({
          id: item?.id?.toString(),
          name: item?.name,
          duration: item?.duration,
          start_date: item?.start_date,
          end_date: item?.end_date,
          domain: item?.domains || [],
          level: item?.level || "-",
        });
      });
    }
    setOldAddedLearningPlans(addedIds);
    setUserCardDetail(addedCards);
    setAddedLearningPlans(addedIds);
  }, [userGroupByIdByUserId]);

  useEffect(() => {
    dispatch(
      getUserGroupByIdByUserId({
        id: group_id,
        user_id: selectedId,
      })
    );
  }, [group_id, selectedId, openModal]);

  const toggleModal = () => {
    if (openModal) {
      setAddedLearningPlans([]);
      setOldAddedLearningPlans([]);
      setUserCardDetail([]);
    }
    handleModal();
  };

  const onHandleDone = async () => {
    const diff =
      oldAddedLearningPlans?.filter(item => {
        return !addedLearningPlans.includes(item);
      }) || [];

    if (diff && diff?.length > 0) {
      await dispatch(
        deleteUserPlanByIds({
          id: group_id,
          user_id: selectedId,
          payload: {
            plans: diff,
          },
        })
      );
    }

    const added = [];
    userCardDetail?.map(item => {
      if (addedLearningPlans.includes(Number(item?.id)))
        added.push({
          group_id: group_id,
          plan_id: item?.id,
          user_id: selectedId,
          start_date: formatDate(item?.start_date),
          end_date: formatDate(item?.end_date),
        });
    });

    const payload = {
      user_plans: added,
    };
    await dispatch(updateUserInduvidualPlan({ payload: payload }));
    toggleModal();
  };

  return (
    <div className="plan-details">
      <Modal
        isOpen={openModal}
        toggle={toggleModal}
        className="modal-body plan-details__modal"
        centered={true}
        size="xl"
      >
        <ModalHeader toggle={toggleModal}>
          <H4>Add / Modify Learning Plan for {learningPlan}</H4>
        </ModalHeader>
        <Divider />
        <ModalBody>
          <LearningPlanContainer
            learningPlanId={group_id}
            addedLearningPlans={addedLearningPlans}
            setAddedLearningPlans={setAddedLearningPlans}
            userCardDetail={userCardDetail}
            setUserCardDetail={setUserCardDetail}
          />
        </ModalBody>
        <ModalFooter>
          <Btn color="primary" onClick={onHandleDone}>
            {Done}
          </Btn>
        </ModalFooter>
      </Modal>
    </div>
  );
};

ModifyLearningPlan.propTypes = {
  group_id: PropTypes.string,
  selectedId: PropTypes.string,
  openModal: PropTypes.bool,
  handleModal: PropTypes.func,
  learningPlan: PropTypes.string,
};

export default ModifyLearningPlan;
